import { IChoiceGroupOption } from '@fluentui/react';
import { ChoiceGroup, choiceGroupStylesHorizontalBox, IMessageBarMessage, useClassNames } from '@h2oai/ui-kit';
import { useCallback, useRef, useState } from 'react';

import { Project } from '../../featurestore/gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { CreateUpdateProject } from '../CreateUpdateProject/CreateUpdateProject';
import { SelectProject } from '../SelectProject/SelectProject';
import {
  IRegisterFeatureSetSelectProjectClassNames,
  IRegisterFeatureSetSelectProjectStyles,
  registerFeatureSetSelectProjectStylesDefault,
} from './RegisterFeatureSetSelectProject.styles';

enum Labels {
  selectExistingProject = 'Select an existing project',
  addANewProject = 'Add a new project',
}

const getOptions = (count: number): IChoiceGroupOption[] => {
  return [
    { key: Labels.selectExistingProject, text: Labels.selectExistingProject, disabled: count === 0 },
    { key: Labels.addANewProject, text: Labels.addANewProject },
  ];
};

interface IRegisterFeatureSetSelectProjectProps {
  onDismiss: () => void;
  onSelect: (project?: Project, message?: IMessageBarMessage) => void;
}

export const RegisterFeatureSetSelectProject = ({ onSelect, onDismiss }: IRegisterFeatureSetSelectProjectProps) => {
  const [projectOptionLabel, setProjectOptionLabel] = useState(Labels.selectExistingProject);
  const [projectCount, setProjectCount] = useState(0);
  const refMeta = useRef<{ checkedProjectCount?: boolean }>({});
  const onChange = useCallback((_e?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => {
    if (option) {
      setProjectOptionLabel(option.key as Labels);
    }
  }, []);
  const classNames = useClassNames<IRegisterFeatureSetSelectProjectStyles, IRegisterFeatureSetSelectProjectClassNames>(
    'RegisterFeatureSetSelectProject',
    registerFeatureSetSelectProjectStylesDefault
  );
  return (
    <div className={classNames.root} data-test="register-feature-set-project">
      <ChoiceGroup
        styles={choiceGroupStylesHorizontalBox}
        options={getOptions(projectCount)}
        required
        label="Select how do you want to create your project ?"
        selectedKey={projectOptionLabel}
        onChange={onChange}
      />
      <div className={classNames.body}>
        {projectOptionLabel === Labels.selectExistingProject && (
          <SelectProject
            onCancel={onDismiss}
            onSelect={onSelect}
            onUpdateList={(count) => {
              if (!refMeta.current.checkedProjectCount) {
                refMeta.current.checkedProjectCount = true;
                setProjectCount(count);
                setProjectOptionLabel(count > 0 ? Labels.selectExistingProject : Labels.addANewProject);
              }
            }}
          />
        )}
        {projectOptionLabel === Labels.addANewProject && (
          <CreateUpdateProject
            onCancel={onDismiss}
            onUpdate={(project, _deleted, message) => onSelect(project, message)}
          />
        )}
      </div>
    </div>
  );
};
